import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import endpoints from '../endpoints.ts';
import api from '../api/index.ts';
import { Toast } from '../types/models';
import { USER_QUERY_KEY } from '../queryHooks/userQueryHooks.ts';
import { UserAPI } from '../api/user';

const useUpdateOtherSettings = (
  options?: Partial<
    UseMutationOptions<
      Toast | null,
      unknown,
      UserAPI.Request.UpdateOtherSettings
    >
  >
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [USER_QUERY_KEY, endpoints.user.update.otherSettings()],
    mutationFn: api.user.update.otherSettings,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [USER_QUERY_KEY],
      });
    },
    ...options,
  });
};

const useUpdateEmailAddress = (
  options?: Partial<
    UseMutationOptions<
      Toast | null,
      unknown,
      UserAPI.Request.UpdateEmailAddress
    >
  >
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [endpoints.user.update.emailAddress()],
    mutationFn: api.user.update.emailAddress,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [USER_QUERY_KEY, endpoints.user.read.one.by.id()],
      });
    },
    ...options,
  });
};

const useCreateEmailAddressToken = (
  options?: Partial<
    UseMutationOptions<
      Toast | null,
      unknown,
      UserAPI.Request.UpdateEmailAddress
    >
  >
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [endpoints.user.create.emailAddressToken()],
    mutationFn: api.user.create.emailAddressToken,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [USER_QUERY_KEY],
      });
    },
    ...options,
  });
};

const userMutationHooks = {
  useUpdateOtherSettings,
  useUpdateEmailAddress,
  useCreateEmailAddressToken,
};

export default userMutationHooks;
